import { module } from 'angular';
import templateBuilderDatetimeDisplay from './builder/display.html';
import templateBuilderDatetimeData from './builder/data.html';
import templateBuilderDatetimeValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/datetime/display.html', templateBuilderDatetimeDisplay);
	$templateCache.put('kform/components/datetime/data.html', templateBuilderDatetimeData);
	$templateCache.put('kform/components/datetime/validate.html', templateBuilderDatetimeValidate);
});
